import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSubIndicator(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M2.5 8v4a1 1 0 0 0 1 1h14.086l-2.793 2.793a1 1 0 0 0 1.414 1.414L21.414 12l-5.207-5.207a1 1 0 1 0-1.414 1.414L17.586 11H4.5V8a1 1 0 0 0-2 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
